import * as React from 'react';
import { monitorRouterMatch, ProtectedRoute } from '../../common/components';
import { TrainingProjectsScreen, TrainingProjectDashboardScreen } from '../screens';
import { STORE_TRAINING_PROJECTS } from '../stores/constants';

export const TrainingProjectsNavigation = {
    TrainingProjectsScreen: '/projects/:projectId/training-projects',
    TrainingProjectDashboardScreen: '/projects/:projectId/training-projects/:trainingProjectId/dashboard'
};

export default () => {
    return (
        <>
            <ProtectedRoute
                component={TrainingProjectsScreen}
                path={TrainingProjectsNavigation.TrainingProjectsScreen}
                exact
            />
            <ProtectedRoute
                component={monitorRouterMatch(STORE_TRAINING_PROJECTS, (s, m) =>
                    s[STORE_TRAINING_PROJECTS].matchCurrentTrainingProjectData(m!.params)
                )(TrainingProjectDashboardScreen)}
                path={TrainingProjectsNavigation.TrainingProjectDashboardScreen}
                exact
            />
        </>
    );
};
